// dependencies
import { fromJS } from "immutable";

const Labels = {
	// feedback
	aboutList: { label: "Subject" },
	shareWith: { label: "Sharing" },
	message: { label: "Message" },

	// create review cycle
	startDate: { label: "Start Date" },
};

export default fromJS(Labels);
